module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/pc/contacts/img_about03-73be6f5a06bed009c27d0c705ba94d0b.jpg";